import Question from './question';
import * as constants from '../constants';
import GridTool from '../tools/grid/grid-tool';

export default class GridQuestion extends Question {
  /**
   * @property {PIXI.Rectangle} answer
   */

  constructor() {
    super(...arguments);
  }

  set answer( val ) {
    super.answer = val;

    if ( this.answer instanceof PIXI.Rectangle ) { // strip type property from json
      this.answer.toJSON = function () {
        const { x, y, width, height } = this;
        return { x, y, width, height };
      };
    }
  }
  get answer() {
    return super.answer;
  }
  get tool() {
    return GridTool;
  }
  get title() {
    return `Show ${ this.multiplicand } ${ constants.multiplicationSign } ${ this.multiplier }`;
  }
  get result() {
    return !!this.answer && (
      ( this.answer.width === this.multiplicand && this.answer.height === this.multiplier ) ||
      ( this.answer.width === this.multiplier && this.answer.height === this.multiplicand )
    );
  }

  correctSolution() {
    const rect = new PIXI.Rectangle;
    rect.width = this.multiplicand;
    rect.height = this.multiplier;
    rect.x = Math.min(this.answer ? this.answer.x : 0, 12 - rect.width);
    rect.y = Math.min(this.answer ? this.answer.y : 0, 12 - rect.height);
    return rect;
  }
}
